import { People, Person, UserIconFilled } from '@/components/icons'
import { Player } from '@/types'

export type PlayerItemProps = {
  player: Player
  className?: string
}

export const PlayerItem = ({ player, className }: PlayerItemProps) => {
  return (
    <div className={`flex p-4 justify-between w-full cursor-pointer bg-white rounded-2xl ${className}`}>
      <div className="flex gap-x-2 w-full truncate">
        <div className="rounded-full">
          <div className="w-10 h-10 relative">
            <div className="absolute flex flex-col items-center justify-center">
              {player?.imageUrl ? (
                <img src={player?.imageUrl} className="rounded-full w-10 h-10" alt="" />
              ) : (
                <UserIconFilled className="w-10 h-10 text-primary-500" />
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col truncate">
          <span className="text-sm font-semibold text-navy-900 truncate">{player?.fullName || player?.fullname}</span>
          <span className="text-navy-900 text-sm font-semibold text-opacity-50">{player?.referralCode}</span>
          <span className="text-xs font-normal text-navy-900 text-opacity-80 truncate">{player?.shortAddress}</span>
          <span className="text-xs font-normal text-navy-900 text-opacity-60 truncate">
            {player?.age}
            {player?.gender ? ` • ${player?.gender[0]}` : ''}
          </span>
        </div>
      </div>
      <div className="flex gap-x-1 items-center">
        <div className="bg-navy-900 bg-opacity-10 rounded-lg px-2 py-1 w-11 h-10 flex flex-col justify-center items-center">
          <People className="text-navy-900" />
          <span className="text-xs text-navy-900 font-medium">{player?.ratings?.doubles}</span>
        </div>
        <div className="bg-navy-900 bg-opacity-10 rounded-lg px-2 py-1 w-11 h-10 flex flex-col justify-center items-center">
          <Person className="text-navy-900" />
          <span className="text-xs text-navy-900 font-medium">{player?.ratings?.singles}</span>
        </div>
      </div>
    </div>
  )
}

export default PlayerItem
